import FormGroup from '@mui/material/FormGroup';

import { Checkbox, FormControl } from '@ifs-gcp/components';
import { Alignment } from '@ifs-gcp/core/models';

import type { AnswerProps } from '@/types/question';
import { getTranslation } from '@/utils/translations';

export const CheckboxAnswer = ({
  answer,
  error,
  language,
  onBlur,
  onChange,
  question: {
    props: { id: questionId, alignment, options = [], disabledCondition },
  },
}: AnswerProps<string[]>) => {
  return (
    <FormControl error={Boolean(error)} helperText={error}>
      <FormGroup row={alignment !== Alignment.Vertical}>
        {options.map(({ value: optionValue, text, disabledCondition: optionDisabledCondition }) => (
          <Checkbox
            key={optionValue}
            label={getTranslation(text, language)}
            checked={answer.includes(optionValue)}
            onBlur={() => {
              if (onBlur) {
                onBlur(answer);
              }
            }}
            onChange={(event) => {
              if (event.target.checked) {
                onChange([...answer, optionValue]);
              } else {
                onChange(answer.filter((element) => element !== optionValue));
              }
            }}
            disabled={disabledCondition || optionDisabledCondition}
            inputProps={{
              id: `${questionId}_${optionValue}`,
            }}
          />
        ))}
      </FormGroup>
    </FormControl>
  );
};
